// Enhanced Quantity-Based Custom Pricing Solution with Shape Selection - OPTIMIZED VERSION
// CUSTOM RUG FUNCTIONALITY - Product page only runs on product.custom-rugs.json template
// Cart count adjustment runs on ALL pages (optimized for performance)

(function() {
    'use strict';
    
    // Early exit flag - check if custom rug template
    let isCustomRugsPage = false;
    let cartCountDebounceTimer = null;
    let isInitialized = false;
    
    // Check if this is a custom-rugs product template (optimized)
    function isCustomRugsTemplate() {
        if (isCustomRugsPage !== false) return isCustomRugsPage;
        
        // Quick check via meta tag first (fastest)
        const customRugsMeta = document.querySelector('meta[name="custom-rugs-template"]');
        if (customRugsMeta && customRugsMeta.content === 'true') {
            isCustomRugsPage = true;
            return true;
        }
        
        // Check template name
        const templateName = document.body.getAttribute('data-template') || '';
        if (templateName.includes('custom-rugs')) {
            isCustomRugsPage = true;
            return true;
        }
        
        // Check class
        if (document.body.classList.contains('template-product-custom-rugs')) {
            isCustomRugsPage = true;
            return true;
        }
        
        isCustomRugsPage = false;
        return false;
    }

    // Debounced cart count adjustment (prevents multiple calls)
    function adjustCartCount() {
        if (cartCountDebounceTimer) {
            clearTimeout(cartCountDebounceTimer);
        }
        
        cartCountDebounceTimer = setTimeout(function() {
            const cartCountElements = document.querySelectorAll('[data-cart-count], .cartCount, .cart-count-bubble .text');
            if (cartCountElements.length === 0) return;
            
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    if (!cart || !cart.items) return;
                    
                    let adjustedCount = 0;
                    let hasCustomRugItems = false;
                    
                    cart.items.forEach(item => {
                        if (item.properties) {
                            const hasCustomRugProps = Object.keys(item.properties).some(key => {
                                const keyLower = key.toLowerCase();
                                return keyLower.includes('shape') || keyLower.includes('width') || 
                                       keyLower.includes('height') || keyLower.includes('diameter') || 
                                       keyLower.includes('base price') || keyLower.includes('area');
                            });
                            
                            if (hasCustomRugProps) {
                                adjustedCount += 1;
                                hasCustomRugItems = true;
                            } else {
                                adjustedCount += item.quantity;
                            }
                        } else {
                            adjustedCount += item.quantity;
                        }
                    });
                    
                    if (hasCustomRugItems) {
                        cartCountElements.forEach(el => {
                            if (el.textContent !== undefined) {
                                el.textContent = adjustedCount;
                            }
                        });
                    }
                })
                .catch(() => {});
        }, 200);
    }
  
    // Get first variant price (base price)
    function getFirstVariantPrice() {
        const lastvarientprice = document.getElementById("lastvarientPrice");
        if (lastvarientprice && lastvarientprice.value && lastvarientprice.value !== 'undefined') {
            return parseFloat(lastvarientprice.value) / 100;
        }
        return 100;
    }

    // Calculate area based on shape
    function calculateArea(shape, dimensions) {
        const { width, height, diameter } = dimensions;
        
        switch(shape) {
            case 'rectangle':
            case 'runner':
                return width * height;
            case 'square':
                return width * width;
            case 'round':
                return diameter * diameter;
            default:
                return width * height;
        }
    }

    // Calculate required quantity to match custom price
    function calculateRequiredQuantity(customPrice, basePrice) {
        return Math.ceil(customPrice / basePrice);
    }

    // Variant picker helpers
    function getVariantPickerRoot() {
        return document.querySelector('variant-radios.product-option') ||
               document.querySelector('variant-radios') ||
               document.querySelector('variant-selects') ||
               null;
    }

    function hideVariantPickerForCustomRug() {
        const root = getVariantPickerRoot();
        if (!root) return;
        if (!root.dataset.customRugPrevDisplay) {
            root.dataset.customRugPrevDisplay = root.style.display || '';
        }
        root.style.display = 'none';
        root.dataset.customRugHidden = 'true';
    }

    function showVariantPickerForCustomRug() {
        const root = getVariantPickerRoot();
        if (!root) return;
        if (root.dataset.customRugHidden === 'true') {
            root.style.display = root.dataset.customRugPrevDisplay || '';
            delete root.dataset.customRugPrevDisplay;
            delete root.dataset.customRugHidden;
        }
    }

    function selectFirstVariant() {
        const radioVariants = document.querySelectorAll('input[type="radio"][name^="Size"]');
        if (radioVariants.length > 0) {
            const firstRadio = radioVariants[0];
            firstRadio.checked = true;
            firstRadio.dispatchEvent(new Event('change', { bubbles: true }));
            return;
        }

        const variantSelect = document.querySelector('.product-form select[name="id"]');
        if (variantSelect && variantSelect.options.length > 0) {
            variantSelect.value = variantSelect.options[0].value;
            variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    function selectLastVariant() {
        const radioVariants = document.querySelectorAll('input[type="radio"][name^="Size"]');
        if (radioVariants.length > 0) {
            const lastRadio = radioVariants[radioVariants.length - 1];
            if (lastRadio) {
                lastRadio.checked = true;
                lastRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    // Get shape frame SVG
    function getShapeFrame(shape, width, height, diameter) {
        const svgWidth = 100;
        const svgHeight = 80;
        
        switch(shape) {
            case 'rectangle':
            case 'runner':
                const rectWidth = width && height ? Math.min(svgWidth * 0.7, (width / height) * (svgHeight * 0.5)) : svgWidth * 0.7;
                const rectHeight = width && height ? Math.min(svgHeight * 0.5, (height / width) * (svgWidth * 0.7)) : svgHeight * 0.5;
                const rectX = (svgWidth - rectWidth) / 2;
                const rectY = (svgHeight - rectHeight) / 2;
                const dimText = width && height ? `<text x="${svgWidth/2}" y="${svgHeight - 5}" text-anchor="middle" font-size="10" fill="#999">${width} × ${height}</text>` : '';
                return `<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">
                    <rect x="${rectX}" y="${rectY}" width="${rectWidth}" height="${rectHeight}" fill="none" stroke="#ddd" stroke-width="1.5" stroke-dasharray="3,3"/>
                    ${dimText}
                </svg>`;
            
            case 'square':
                const squareSize = svgWidth * 0.5;
                const squareX = (svgWidth - squareSize) / 2;
                const squareY = (svgHeight - squareSize) / 2;
                const sqText = width ? `<text x="${svgWidth/2}" y="${svgHeight - 5}" text-anchor="middle" font-size="10" fill="#999">${width} × ${width}</text>` : '';
                return `<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">
                    <rect x="${squareX}" y="${squareY}" width="${squareSize}" height="${squareSize}" fill="none" stroke="#ddd" stroke-width="1.5" stroke-dasharray="3,3"/>
                    ${sqText}
                </svg>`;
            
            case 'round':
                const radius = svgWidth * 0.25;
                const centerX = svgWidth / 2;
                const centerY = svgHeight / 2;
                const roundText = diameter ? `<text x="${svgWidth/2}" y="${svgHeight - 5}" text-anchor="middle" font-size="10" fill="#999">Ø ${diameter}</text>` : '';
                return `<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">
                    <circle cx="${centerX}" cy="${centerY}" r="${radius}" fill="none" stroke="#ddd" stroke-width="1.5" stroke-dasharray="3,3"/>
                    ${roundText}
                </svg>`;
            
            default:
                const defWidth = svgWidth * 0.7;
                const defHeight = svgHeight * 0.5;
                const defX = (svgWidth - defWidth) / 2;
                const defY = (svgHeight - defHeight) / 2;
                return `<svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}">
                    <rect x="${defX}" y="${defY}" width="${defWidth}" height="${defHeight}" fill="none" stroke="#ddd" stroke-width="1.5" stroke-dasharray="3,3"/>
                </svg>`;
        }
    }

    // Update quantity display and calculation
    function updateQuantityAndPrice() {
        const shapeSelect = document.getElementById('shape-select');
        if (!shapeSelect) return;

        const widthInput = document.getElementById('width-input');
        const heightInput = document.getElementById('height-input');
        const diameterInput = document.getElementById('diameter-input');
        const priceDisplay = document.getElementById('calculated-price-display');
        const areaDisplay = document.getElementById('area-display');
        const shapeFrame = document.getElementById('shape-frame');
        const hiddenPriceInput = document.getElementById('calculated-price-hidden');
        const hiddenAreaInput = document.getElementById('total-area-hidden');
        const hiddenQtyInput = document.getElementById('required-quantity-hidden');

        const shape = shapeSelect.value;
        const width = parseFloat(widthInput?.value) || 0;
        const height = parseFloat(heightInput?.value) || 0;
        const diameter = parseFloat(diameterInput?.value) || 0;
     
        // Update hidden inputs - CRITICAL: Set all property values like old code
        const shapeHidden = document.getElementById('shape-hidden');
        const widthHidden = document.getElementById('width-hidden');
        const heightHidden = document.getElementById('height-hidden');
        const diameterHidden = document.getElementById('diameter-hidden');
        
        // CRITICAL: Set BOTH hidden AND visible input values
        // Visible inputs (with name="properties[...]") will be submitted by form
        if (shapeHidden) shapeHidden.value = shape;
        if (widthHidden) widthHidden.value = width || '';
        if (heightHidden) heightHidden.value = height || '';
        if (diameterHidden) diameterHidden.value = diameter || '';
        
        // Update visible inputs - these have name="properties[...]" so they'll be submitted
        if (shapeSelect) shapeSelect.value = shape;
        if (widthInput && width > 0) widthInput.value = width;
        if (heightInput && height > 0) heightInput.value = height;
        if (diameterInput && diameter > 0) diameterInput.value = diameter;

        updateInputVisibility(shape);

        let isValid = false;
        let area = 0;
        let dimensions = { width, height, diameter };

        switch(shape) {
            case 'rectangle':
            case 'runner':
                isValid = width > 0 && height > 0;
                break;
            case 'square':
                isValid = width > 0;
                dimensions.height = width;
                break;
            case 'round':
                isValid = diameter > 0;
                break;
        }
       
        if (isValid) {
            area = calculateArea(shape, dimensions);
            const basePrice = getFirstVariantPrice();
            const pricePerSqFt = basePrice; 
            const customCalculatedPrice = area * pricePerSqFt;

            const rugQtyInput = document.getElementById('rug-qty-input');
            const rugQty = Math.max(1, parseInt(rugQtyInput?.value || '1', 10) || 1);

            const requiredQtyPerRug = calculateRequiredQuantity(customCalculatedPrice, basePrice);
            const requiredQty = requiredQtyPerRug * rugQty;

            const totalPrice = customCalculatedPrice * rugQty;
            const totalArea = area * rugQty;
            
            if (priceDisplay) priceDisplay.innerHTML = `$${totalPrice.toFixed(2)}`;
            if (areaDisplay) areaDisplay.innerHTML = `${totalArea.toFixed(2)} sq ft`;
            if (shapeFrame) shapeFrame.innerHTML = getShapeFrame(shape, dimensions.width, dimensions.height, diameter);

            const quantityInputs = document.querySelectorAll('input[name="quantity"], .quantity__input');
            quantityInputs.forEach(input => {
                input.value = requiredQty;
            });

            let hiddenQtyField = document.getElementById('required-quantity-hidden');
            if (!hiddenQtyField) {
                const form = document.querySelector('form[action*="/cart/add"]');
                if (form) {
                    hiddenQtyField = document.createElement('input');
                    hiddenQtyField.type = 'hidden';
                    hiddenQtyField.id = 'required-quantity-hidden';
                    hiddenQtyField.name = 'quantity';
                    form.appendChild(hiddenQtyField);
                }
            }
            if (hiddenQtyField) hiddenQtyField.value = requiredQty;

            // CRITICAL: Update visible inputs AND hidden inputs in product-button.liquid
            // Visible inputs (shape-select, width-input, etc.) have name="properties[...]"
            // Hidden inputs in product-button.liquid also need to be updated
            
            // Update visible inputs (these are in calculator, inside form)
            if (shapeSelect) shapeSelect.value = shape;
            if (widthInput) widthInput.value = width || '';
            if (heightInput) heightInput.value = height || '';
            if (diameterInput) diameterInput.value = diameter || '';
            
            // Update hidden inputs in calculator
            if (shapeHidden) shapeHidden.value = shape;
            if (widthHidden) widthHidden.value = width || '';
            if (heightHidden) heightHidden.value = height || '';
            if (diameterHidden) diameterHidden.value = diameter || '';
            
            // Update hidden inputs in product-button.liquid (if they exist)
            const form = document.querySelector('form[data-type="add-to-cart-form"]') || 
                        document.querySelector('form[action*="/cart/add"]');
            if (form) {
                const btnShapeHidden = form.querySelector('#shape-hidden');
                const btnWidthHidden = form.querySelector('#width-hidden');
                const btnHeightHidden = form.querySelector('#height-hidden');
                const btnDiameterHidden = form.querySelector('#diameter-hidden');
                
                if (btnShapeHidden) btnShapeHidden.value = shape;
                if (btnWidthHidden) btnWidthHidden.value = width || '';
                if (btnHeightHidden) btnHeightHidden.value = height || '';
                if (btnDiameterHidden) btnDiameterHidden.value = diameter || '';
                
                // Add Area hidden input in form (like Width/Height) - CRITICAL for cart display
                let btnAreaHidden = form.querySelector('input[name="properties[Area]"]');
                if (!btnAreaHidden) {
                    // Create Area hidden input in form if it doesn't exist
                    btnAreaHidden = document.createElement('input');
                    btnAreaHidden.type = 'hidden';
                    btnAreaHidden.name = 'properties[Area]';
                    btnAreaHidden.id = 'area-hidden-form';
                    form.appendChild(btnAreaHidden);
                }
                // Update Area value
                btnAreaHidden.value = `${totalArea.toFixed(2)} sq.ft`;
            }
            
            // Set Calculated Price in hidden input
            if (hiddenPriceInput) {
                hiddenPriceInput.value = `$${totalPrice.toFixed(2)}`;
            }
            
            // Set Area in hidden input in calculator (backup)
            if (hiddenAreaInput) {
                hiddenAreaInput.value = `${totalArea.toFixed(2)} sq.ft`;
            }

            // Set Rug Qty in hidden input
            const rugQtyProp = document.getElementById('rug-qty-hidden');
            if (rugQtyProp) {
                rugQtyProp.value = `${rugQty}`;
            }
            
            // Base Price is already set in HTML when calculator is created

            updateProductSubtotalDisplay(totalPrice);
            enableAddToCartButton();

        } else {
            if (priceDisplay) priceDisplay.innerHTML = 'Enter dimensions';
            if (areaDisplay) areaDisplay.innerHTML = '';
            if (shapeFrame) shapeFrame.innerHTML = getShapeFrame(shape);

            if (hiddenPriceInput) hiddenPriceInput.value = '';
            if (hiddenAreaInput) hiddenAreaInput.value = '';
            if (hiddenQtyInput) hiddenQtyInput.value = '';

            updateQuantityInput(1);
            disableAddToCartButton();
        }
    }

    function updateProductSubtotalDisplay(totalPriceDollars) {
        const subtotalEl = document.querySelector('.productView-subtotal .money') ||
                          document.querySelector('.productView-subtotal .money-subtotal');
        if (subtotalEl) {
            subtotalEl.textContent = `$${Number(totalPriceDollars || 0).toFixed(2)}`;
        }
    }

    function updateInputVisibility(shape) {
        const widthGroup = document.getElementById('width-group');
        const heightGroup = document.getElementById('height-group');
        const diameterGroup = document.getElementById('diameter-group');
        const widthLabel = document.querySelector('label[for="width-input"]');
        const heightLabel = document.querySelector('label[for="height-input"]');
        const shapeFrame = document.getElementById('shape-frame');

        if (widthGroup) widthGroup.style.display = 'none';
        if (heightGroup) heightGroup.style.display = 'none';
        if (diameterGroup) diameterGroup.style.display = 'none';

        if (shapeFrame) {
            shapeFrame.innerHTML = getShapeFrame(shape);
        }

        switch(shape) {
            case 'rectangle':
            case 'runner':
                if (widthGroup) widthGroup.style.display = 'block';
                if (heightGroup) heightGroup.style.display = 'block';
                if (widthLabel) widthLabel.textContent = 'Width (ft)';
                if (heightLabel) heightLabel.textContent = 'Length (ft)';
                break;
            case 'square':
                if (widthGroup) widthGroup.style.display = 'block';
                if (widthLabel) widthLabel.textContent = 'Size (ft)';
                break;
            case 'round':
                if (diameterGroup) diameterGroup.style.display = 'block';
                break;
        }
    }

    function updateQuantityInput(qty) {
        const quantityInputs = document.querySelectorAll('input[name="quantity"], #Quantity, .quantity__input');
        quantityInputs.forEach(input => {
            input.value = qty;
        });
    }

    function createCustomSizeButton() {
        return `<button type="button" id="custom-size-btn" class="custom-size-button">Customize Your Rug</button>`;
    }

    function createCalculatorHTML() {
        const basePrice = getFirstVariantPrice();
        return `
            <div class="custom-size-calculator" id="custom-size-calculator" style="display: none;">
                <div class="calculator-header">
                    <h3>Custom Size Calculator</h3>
                    <button type="button" class="close-calculator" id="close-calculator">×</button>
                </div>
                <div class="calculator-content-compact">
                    <div class="dimensions-row">
                        <div class="shape-selector-compact">
                            <label for="shape-select">Shape:</label>
                            <select id="shape-select" name="properties[Shape]">
                                <option value="rectangle">Rectangle</option>
                                <option value="square">Square</option>
                                <option value="round">Round</option>
                                <option value="runner">Runner</option>
                            </select>
                        </div>
                        <div class="dimensions-inputs-compact">
                            <div class="input-group-compact" id="width-group">
                                <label for="width-input">Width (ft)</label>
                                <input type="number" id="width-input" name="properties[Width]" min="1" step="0.1" placeholder="Width">
                            </div>
                            <div class="input-group-compact" id="height-group">
                                <label for="height-input">Length (ft)</label>
                                <input type="number" id="height-input" name="properties[Height]" min="1" step="0.1" placeholder="Length">
                            </div>
                            <div class="input-group-compact" id="diameter-group" style="display: none;">
                                <label for="diameter-input">Diameter (ft)</label>
                                <input type="number" id="diameter-input" name="properties[Diameter]" min="1" step="0.1" placeholder="Diameter">
                            </div>
                        </div>
                        <div class="shape-preview-compact">
                            <div id="shape-frame"></div>
                        </div>
                    </div>
                    <div class="results-row">
                        <div class="area-display-compact">
                            <span class="label">Area:</span>
                            <span id="area-display">-</span>
                        </div>
                        <div class="price-display-compact">
                            <span class="label">Price:</span>
                            <span id="calculated-price-display">Enter dimensions</span>
                        </div>
                        <button type="button" id="calculate-btn" class="calculate-button-compact">CALCULATE</button>
                    </div>
                    <div class="results-row" style="margin-top: 10px;">
                        <div class="area-display-compact">
                            <span class="label">Qty:</span>
                        </div>
                        <div style="display:flex; gap:8px; align-items:center;">
                            <button type="button" id="rug-qty-minus" class="calculate-button-compact" style="width:auto; padding:6px 10px;">-</button>
                            <input id="rug-qty-input" type="number" min="1" step="1" value="1" style="width:60px; text-align:center; padding:6px 8px;">
                            <button type="button" id="rug-qty-plus" class="calculate-button-compact" style="width:auto; padding:6px 10px;">+</button>
                        </div>
                    </div>
                </div>
                <input type="hidden" id="shape-hidden" name="properties[Shape]" value="">
                <input type="hidden" id="width-hidden" name="properties[Width]" value="">
                <input type="hidden" id="height-hidden" name="properties[Height]" value="">
                <input type="hidden" id="diameter-hidden" name="properties[Diameter]" value="">
                <input type="hidden" id="calculated-price-hidden" name="properties[Calculated Price]" value="">
                <input type="hidden" id="total-area-hidden" name="properties[Area]" value="">
                <input type="hidden" id="rug-qty-hidden" name="properties[Rug Qty]" value="1">
                <input type="hidden" name="properties[Base Price]" value="${basePrice}">
                <div class="calculator-note-compact">
                    <strong>Note:</strong> Cart will show equivalent quantity to match your custom price.
                </div>
            </div>
        `;
    }

    function hidePriceAndQuantity() {
        const priceSelectors = ['.price-item--regular', '.price-item--sale', '.productView-price', '.price--on-sale', '.price--regular', '[class*="price-item"]', '.product-form__price', '.product-price', 'span.price', '.productView-price .price'];
        priceSelectors.forEach(selector => {
            try {
                document.querySelectorAll(selector).forEach(el => {
                    const productForm = el.closest('.product-form, .productView, form[action*="/cart/add"]');
                    if (productForm) {
                        el.style.display = 'none';
                        el.setAttribute('data-custom-rug-hidden', 'true');
                    }
                });
            } catch(e) {}
        });

        const quantitySelectors = ['.product-form__quantity', '.quantity__group', '.quantity__container', '[class*="quantity"]', 'label[for*="quantity"]', '.productView-quantity'];
        quantitySelectors.forEach(selector => {
            try {
                document.querySelectorAll(selector).forEach(el => {
                    const productForm = el.closest('.product-form, .productView, form[action*="/cart/add"]');
                    if (productForm && !el.closest('#custom-size-calculator')) {
                        el.style.display = 'none';
                        el.setAttribute('data-custom-rug-hidden', 'true');
                    }
                });
            } catch(e) {}
        });
    }

    function showPriceAndQuantity() {
        document.querySelectorAll('[data-custom-rug-hidden="true"]').forEach(el => {
            if (el.classList.contains('price') || el.closest('.productView-price, .product-form__price')) {
                el.style.display = '';
                el.removeAttribute('data-custom-rug-hidden');
            }
            if (el.classList.contains('quantity') || el.closest('.product-form__quantity, .quantity__group')) {
                el.style.display = '';
                el.removeAttribute('data-custom-rug-hidden');
            }
        });
    }

    function insertCustomSizeComponents() {
        const variantSelects = document.querySelector('variant-radios.product-option');
        if (variantSelects) {
            // Insert custom size button after variant selects (like old code)
            variantSelects.insertAdjacentHTML('afterend', createCustomSizeButton());
            
            // Insert calculator after the button
            const customSizeBtn = document.getElementById('custom-size-btn');
            if (customSizeBtn) {
                customSizeBtn.insertAdjacentHTML('afterend', createCalculatorHTML());
                
                // Initialize shape display immediately after inserting calculator HTML
                setTimeout(() => {
                    const shapeSelect = document.getElementById('shape-select');
                    const shapeFrame = document.getElementById('shape-frame');
                    if (shapeSelect && shapeFrame) {
                        const defaultShape = shapeSelect.value || 'rectangle';
                        shapeFrame.innerHTML = getShapeFrame(defaultShape);
                    }
                }, 50);
            }
        }
    }

    function addEventListeners() {
        const customSizeBtn = document.getElementById('custom-size-btn');
        const closeCalculator = document.getElementById('close-calculator');
        const calculator = document.getElementById('custom-size-calculator');
        const calculateBtn = document.getElementById('calculate-btn');
        const shapeSelect = document.getElementById('shape-select');

        if (customSizeBtn && calculator) {
            customSizeBtn.addEventListener('click', function() {
                calculator.style.display = 'block';
                customSizeBtn.style.display = 'none';
                selectLastVariant();
                hideVariantPickerForCustomRug();
                
                const shapeSelectEl = document.getElementById('shape-select');
                const defaultShape = shapeSelectEl ? shapeSelectEl.value : 'rectangle';
                updateInputVisibility(defaultShape);
                
                hidePriceAndQuantity();
                sessionStorage.setItem('customRugActive', 'true');

                const rugQtyInput = document.getElementById('rug-qty-input');
                const rugMinus = document.getElementById('rug-qty-minus');
                const rugPlus = document.getElementById('rug-qty-plus');

                const clampQty = () => {
                    if (!rugQtyInput) return 1;
                    const v = Math.max(1, parseInt(rugQtyInput.value || '1', 10) || 1);
                    rugQtyInput.value = String(v);
                    const rugQtyHidden = document.getElementById('rug-qty-hidden');
                    if (rugQtyHidden) rugQtyHidden.value = String(v);
                    return v;
                };

                const recomputeIfPossible = () => {
                    const priceDisplay = document.getElementById('calculated-price-display');
                    if (priceDisplay && priceDisplay.textContent && priceDisplay.textContent.includes('$')) {
                        updateQuantityAndPrice();
                    }
                };

                if (rugQtyInput) rugQtyInput.addEventListener('change', () => { clampQty(); recomputeIfPossible(); });
                if (rugMinus) rugMinus.addEventListener('click', () => { if (rugQtyInput) { rugQtyInput.value = String(clampQty() - 1); clampQty(); recomputeIfPossible(); } });
                if (rugPlus) rugPlus.addEventListener('click', () => { if (rugQtyInput) { rugQtyInput.value = String(clampQty() + 1); clampQty(); recomputeIfPossible(); } });
            });
        }

        if (closeCalculator && calculator) {
            closeCalculator.addEventListener('click', function() {
                calculator.style.display = 'none';
                if (customSizeBtn) customSizeBtn.style.display = 'block';
                showVariantPickerForCustomRug();
                selectFirstVariant();
                showPriceAndQuantity();
                sessionStorage.removeItem('customRugActive');
            });
        }

        if (shapeSelect) {
            shapeSelect.addEventListener('change', function() {
                updateInputVisibility(this.value);
                const shapeFrame = document.getElementById('shape-frame');
                if (shapeFrame) {
                    shapeFrame.innerHTML = getShapeFrame(this.value);
                }
            });
        }

        if (calculateBtn) {
            calculateBtn.addEventListener('click', updateQuantityAndPrice);
        }
    }

    function enableAddToCartButton() {
        document.querySelectorAll('[name="add"], .btn-cart, [class*="add-to-cart"], #AddToCart').forEach(button => {
            button.disabled = false;
        });
    }

    function disableAddToCartButton() {
        document.querySelectorAll('[name="add"], .btn-cart, [class*="add-to-cart"], #AddToCart').forEach(button => {
            button.disabled = true;
            button.style.opacity = '0.6';
        });
    }

    function validateForm() {
        const productForms = document.querySelectorAll('form[action*="/cart/add"]');
        productForms.forEach(form => {
            form.addEventListener('submit', function(e) {
                const calculator = document.getElementById('custom-size-calculator');
                if (calculator && calculator.style.display !== 'none') {
                    const qtyInput = document.getElementById('required-quantity-hidden');
                    if (!qtyInput || !qtyInput.value || qtyInput.value === '1') {
                        e.preventDefault();
                        alert('Please calculate your custom size before adding to cart.');
                        return false;
                    }

                    const mainQtyInput = form.querySelector('input[name="quantity"]');
                    if (mainQtyInput && qtyInput.value) {
                        mainQtyInput.value = qtyInput.value;
                    }

                    // Update the main quantity input one final time before submission
                    // Visible inputs (shape-select, width-input, etc.) already have name="properties[...]"
                    // and they're inside calculator div which should be inside form
                    // So they'll be submitted automatically - NO NEED to manipulate them
                    
                    console.log(`Adding to cart: ${qtyInput.value} qty of base product ($${getFirstVariantPrice()} each) = $${(qtyInput.value * getFirstVariantPrice()).toFixed(2)}`);
                    
                    // Debug: Check if properties inputs are in form
                    const allPropertyInputs = form.querySelectorAll('input[name^="properties["], select[name^="properties["]');
                    console.log('Properties inputs in form:', Array.from(allPropertyInputs).map(el => ({
                        name: el.name,
                        value: el.value,
                        id: el.id
                    })));
                }
            });
        });
    }

    function triggerVariantChange() {
        const variantSelect = document.querySelector('.product-form select[name="id"]');
        if (variantSelect && variantSelect.value) {
            variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    function hideCartPriceAndQuantity() {
        const cartItems = document.querySelectorAll('[data-cart-item], .cart-item, .previewCartItem, [data-line]');
        let hasAnyCustomRug = false;
        
        cartItems.forEach(item => {
            const properties = item.querySelectorAll('.cart-item-properties dt, .cart-item-properties dd, .definitionList dt, .definitionList dd');
            let hasCustomRugProps = false;
            
            properties.forEach(prop => {
                const text = prop.textContent.toLowerCase();
                if (text.includes('shape') || text.includes('width') || text.includes('height') || 
                    text.includes('diameter') || text.includes('base price') || 
                    text.includes('area') || text.includes('calculated price')) {
                    hasCustomRugProps = true;
                    hasAnyCustomRug = true;
                }
            });
            
            if (hasCustomRugProps) {
                // Hide price block only
                const priceBlock = item.querySelector('.cart-item-price, .cart-item-block-price, .cart-item-block.cart-item-price');
                if (priceBlock) {
                    priceBlock.style.display = 'none';
                    priceBlock.setAttribute('data-custom-rug-hidden', 'true');
                }
                
                // Hide quantity block only
                const quantityBlock = item.querySelector('.cart-item-quantity, .cart-item-block-quantity, cart-update-quantity, .previewCartItem-qty, .cart-item-block.cart-item-quantity');
                if (quantityBlock) {
                    quantityBlock.style.display = 'none';
                    quantityBlock.setAttribute('data-custom-rug-hidden', 'true');
                }
                
                // IMPORTANT: Ensure properties are VISIBLE (not hidden)
                const propertiesContainer = item.querySelector('.cart-item-properties, .definitionList, .card-properties, dl.cart-item-properties');
                if (propertiesContainer) {
                    propertiesContainer.style.display = '';
                    propertiesContainer.style.visibility = 'visible';
                    propertiesContainer.removeAttribute('data-custom-rug-hidden');
                }
                
                // Also ensure individual property elements are visible
                const propertyElements = item.querySelectorAll('.product-option, .definitionList-key, .definitionList-value, dt.definitionList-key, dd.definitionList-value');
                propertyElements.forEach(propEl => {
                    propEl.style.display = '';
                    propEl.style.visibility = 'visible';
                    propEl.removeAttribute('data-custom-rug-hidden');
                });
            }
        });
        
        if (hasAnyCustomRug) {
            const quantityHeader = document.querySelector('.cart-header-quantity, .cart-header-item.cart-header-quantity');
            if (quantityHeader) quantityHeader.style.display = 'none';
            
            const priceHeader = document.querySelector('.cart-header-price, .cart-header-item.cart-header-price');
            if (priceHeader) priceHeader.style.display = 'none';
        }
        
        adjustCartCount();
    }

    // Initialize - ONLY for custom rug pages
    function init() {
        if (isInitialized) return;
        
        if (isCustomRugsTemplate()) {
            insertCustomSizeComponents();
            triggerVariantChange();
            addEventListeners();
            validateForm();
            
            setTimeout(() => {
                const shapeSelect = document.getElementById('shape-select');
                const shapeFrame = document.getElementById('shape-frame');
                if (shapeSelect && shapeFrame) {
                    shapeFrame.innerHTML = getShapeFrame(shapeSelect.value || 'rectangle');
                }
            }, 100);
        }
        
        // Cart page handling (runs on all pages)
        if (window.location.pathname.includes('/cart') || document.querySelector('[data-cart], [id*="cart"]')) {
            setTimeout(hideCartPriceAndQuantity, 500);
        }
        
        const cartDrawer = document.querySelector('.halo-cart-sidebar, [id*="cart-sidebar"], .previewCart');
        if (cartDrawer) {
            setTimeout(hideCartPriceAndQuantity, 300);
        }
        
        isInitialized = true;
    }

    // Initialize cart count on ALL pages (lightweight)
    function initCartCount() {
        adjustCartCount();
    }

    // Main initialization
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            init();
            initCartCount();
        });
    } else {
        init();
        initCartCount();
    }

    // Event listeners (optimized - only add if needed)
    document.addEventListener('shopify:section:load', function() {
        isInitialized = false;
        init();
        initCartCount();
    });
    
    document.addEventListener('cart:refresh', function() {
        hideCartPriceAndQuantity();
        adjustCartCount();
    });
    
    document.addEventListener('cart:updated', function() {
        hideCartPriceAndQuantity();
        adjustCartCount();
    });

    // Optimized MutationObserver - only observe if cart count elements exist
    const cartCountElements = document.querySelectorAll('[data-cart-count], .cartCount');
    if (cartCountElements.length > 0) {
        const observer = new MutationObserver(function(mutations) {
            let shouldUpdate = false;
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' || mutation.type === 'characterData') {
                    shouldUpdate = true;
                }
            });
            if (shouldUpdate) {
                setTimeout(() => {
                    adjustCartCount();
                    hideCartPriceAndQuantity();
                }, 200);
            }
        });
        
        cartCountElements.forEach(el => {
            observer.observe(el, { childList: true, characterData: true, subtree: true });
        });
    }
})();
